import { FadeIn, StaggerContainer, StaggerItem } from "@/components/ui/motion-wrappers";
import { Card, CardContent } from "@/components/ui/card";
import { Check } from "lucide-react";

export const IntegrationsSection = () => {
    const integrations = [
        "Google & Outlook Calendar",
        "Google My Business",
        "Google Analytics & Ads",
        "Facebook & Instagram",
        "QuickBooks",
        "Xero",
        "Wave",
        "Clio",
        "Stripe",
        "Shopify",
        "WooCommerce",
        "TikTok",
        "LinkedIn",
        "Slack",
        "Printful & Printify",
        "Shippo & ShipStation",
        "ClickUp",
        "Notion",
        "Airtable",
        "Basecamp",
        "Typeform"
    ];

    return (
        <section className="py-24 bg-slate-50 dark:bg-slate-900/50">
            <div className="container mx-auto px-6">
                <div className="max-w-5xl mx-auto">
                    <div className="text-center mb-16">
                        <FadeIn>
                            <h2 className="text-3xl md:text-4xl font-bold mb-4">
                                Connects With Your Favorite Tools
                            </h2>
                            <p className="text-lg text-muted-foreground">
                                Seamlessly integrate with the platforms you use every day.
                            </p>
                        </FadeIn>
                    </div>

                    <StaggerContainer className="flex flex-wrap justify-center gap-3 md:gap-4">
                        {integrations.map((tool, index) => (
                            <StaggerItem key={index}>
                                <div className="flex items-center gap-2 px-6 py-3 bg-white dark:bg-slate-800 rounded-full border border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-md transition-shadow">
                                    <div className="w-2 h-2 rounded-full bg-green-500 shrink-0" />
                                    <span className="font-medium text-sm md:text-base text-slate-700 dark:text-slate-200">
                                        {tool}
                                    </span>
                                </div>
                            </StaggerItem>
                        ))}
                    </StaggerContainer>

                    <FadeIn delay={0.4}>
                        <p className="text-center text-sm text-muted-foreground mt-8">
                            + Thousands more via Zapier & API
                        </p>
                    </FadeIn>
                </div>
            </div>
        </section>
    );
};
